import * as THREE from 'three'
import { useMemo } from 'react'
import { applyProps, useFrame } from '@react-three/fiber'
import { useGLTF } from '@react-three/drei'
import { Overlay } from './index'

export function Buttoncolor(){
  return(
    <div id = "btn" style={{ position: 'absolute', top: 50, right:50, fontSize: '13px', fontFamily:'Grand Sport' , letterSpacing:'.1em'}}>CHANGE COLOR</div>    
  )}


export function Lamborghini(props) {
  const { scene, nodes, materials } = useGLTF('/corvette.glb')
  useMemo(() => {
 
    var basecolor = ['#222222', '#AA3534', '#DB642D', '#F5C015', '#377B95'];
    var k=0;
   
    btn.onclick=changeColor;

    nodes.CarBody_2_Tail_Lights_Red_Cover_0.material = new THREE.MeshPhysicalMaterial({
      color:'#ff1111',
    emissive: '#ff1111',
    emissiveIntensity: 0.5
    })

    nodes.CarBody_2_Daylight_Cover_0.material = new THREE.MeshStandardMaterial({
    color:'#ffffff',  
    
    emissiveIntensity: 2000
    })



    function changeColor(){

      if(k>4)
      {
        k=0;
      }
      
      
      

      nodes.CarBody_1_Car_Paint_0_001.material = new THREE.MeshPhysicalMaterial({
      
        color: basecolor[k],
        roughness: 0.3,
        metalness: .9,
        envMapIntensity: 1,
        clearcoatRoughness: 0,
        clearcoat: .5
        
      })
  
      nodes.CarBody_1_Car_Paint_0.material = new THREE.MeshPhysicalMaterial({
        color: basecolor[k],
        roughness: 0.3,
        metalness: 0.9,
        envMapIntensity: 1,
        clearcoatRoughness: 0,
        clearcoat: .5
        
      })
  
      nodes.CarBody_1_Car_Paint_0_002.material = new THREE.MeshPhysicalMaterial({
        color: basecolor[k],
        roughness: 0.3,
        metalness: 0.9,
        envMapIntensity: 1,
        clearcoatRoughness: 0,
        clearcoat: .5

      })
  
      k++;
    }



    
    
  }, [nodes, materials])
  
  
  return <primitive object={scene}{...props} />
 

}


